export default {
	"uzbekistan_national_media_association" : "O`zbekiston Milliy Media Assotsiatsiyasi",
	'media_platform': "Media platforma",
	"username": "Foydalanuvchi nomi",
	"password": "Parol",
	"sign_in": "Kirish",
	"error": "Xato",
	"approve": "Ma'qullash",
	"success": "Muvaffaqiyatli",
	'login': 'Kirish',
	'create': 'Yaratish',
	'cancel': 'Bekor qilish',
	'delete': 'O\'chirish',
	'really_wanna_delete': 'Haqiqattan o\'chirmoqchimisiz?',
	'search': 'Qidirish',
	'actions': 'Harakatlar',
	'update': 'Yangilash',
	'place': 'Joy',
	'phone': 'Telefon raqam',
	'logo': 'Logotip',
	'total_count': 'Jami',
	'file': 'Fayl',
	'director': 'Direktor',
	'chancery': 'Konselyariya',
	'select_file': 'Faylni tanlang',
	'delete_file': 'Faylni o\'chirish',
	'select_logo': 'Logotip tanlang',
	'delete_logo': 'Logotipni o\'chirish',
	'select_image': 'Rams tanlang',
	'delete_image': 'Rasmni o\'chirish',
	'select': 'Tanlang',
	'save': 'Saqlash',
	'close': 'Yopish',
	'download_file': 'Faylni yuklab olish',
	'forbidden': 'Taqiqlangan',
	'not_found': 'Topilmadi',
	'return_back': 'Orqaga qaytish',


	'ru': 'Ruscha',
	'uz': 'O`zbekcha',

	'name': 'Nomi',
	'organization': 'Tashkilot',
	'date': 'Sana',
	'the_date_of_the': 'O`tkaziladigan sana',
	'address': 'Address',
	'description': 'Tavsif',
	'in_priority': 'Ustuvorlikda',



	'January': 'Yanvar',
	'February': 'Fevral',
	'March': 'Mart',
	'April': 'Aprel',
	'May': 'May',
	'June': 'Iyun',
	'July': 'Iyul',
	'August': 'Avgust',
	'September': 'Sentyabr',
	'October': 'Oktyabr',
	'November': 'Noyabr',
	'December': 'Dekabr',


	'Monday': 'Du',
	'Tuesday': 'Se',
	'Wednesday': 'Ch',
	'Thursday': 'Pa',
	'Friday': 'Ju',
	'Saturday': 'Sh',
	'Sunday': 'Yk',


	'main_information': 'Umumiy ma\'lumot',


	'events': 'Tadbirlar',
	'event': 'Tadbir',
	'create_new_event': 'Yangi tadbir yaratish',
	'no_events': 'Tadbirlar yo\'q',
	'open_event': 'Tadbirni ochish',
	'from_date': 'Sanadan',
	'to_date': 'Sanagacha',
	'add_link': 'Havola qo\'shish',
	'link': 'Havola',
	'participate_channels': 'Ishtirokchi kanallar',
	'subscribed_users': 'Obuna bo\'lgan foydalanuvchilar',
	'export_excel': 'Excelga eksport qilish',
	'participate': 'Ishtirok etish',
	'unparticipate': 'Ishtirok etmaslik',
	'subscribe': 'Obuna bo\'lish',
	'unsubscribe': 'Obunani bekor qilish',
	'update_event': 'Tadbirni yangilash',
	'really_wanna_participate': 'Haqiqattan ishtirok etmoqchimisiz?',
	'really_wanna_unparticipate': 'Haqiqattan ishtirok etishni bekor qilmoqchimisiz?',
	'really_wanna_subscribe': 'Haqiqattan obuna etmoqchimisiz?',
	'really_wanna_unsubscribe': 'Haqiqattan obunani bekor qilmoqchimisiz?',

	'channels': 'Kanallar',
	'channel': 'Kanal',
	'no_channels': 'Kanal yo\'q',
	'create_new_channel': 'Yangi kanal yaratish',
	'score': 'Bal',

	'users': 'Foydalanuvchilar',
	'user': 'Foydalanuvchi',
	'full_name': 'FIO',
	'email': 'El.pochta',
	'create_new_user': 'Yangi foydalanuvchi yaratish',
	'no_users': 'Foydalanuvchilar yo\'q',
	'image': 'Rasm',
	'update_user': 'Foydalanuvchini yangilash',

	'roles': 'Rollar',
	'role': 'Rol',
	'no_roles': 'Rollar yo\'q',

	'permissions': 'Ruxsatlar',
	'permission': 'Ruxsat',
	'no_permissions': 'Ruxsatlar yo\'q',
}